import { GoalModel } from '@models/goals';
import { GoalSubscriptionModel } from '@models/goalSubscriptions';
import { BasicGoalSubscriptionModel } from '@models/shared';
import classNames from 'classnames';
import GoalCard from './RedesignedGoalCard';

interface GoalCardsGridProps extends React.HTMLAttributes<HTMLDivElement> {
  embed?: boolean;
  subscriptions?: GoalSubscriptionModel[];
  goals?: GoalModel[];
  showActions?: {
    versionType: boolean;
    like: boolean;
    share: boolean;
    more: boolean;
    edit: boolean;
  };
  className?: string;
}

interface CardContent {
  key: string | number;
  goal: GoalModel;
  subscription?: GoalSubscriptionModel | BasicGoalSubscriptionModel;
}

const renderCards = (
  cardContents: CardContent[],
  showActions?: {
    versionType: boolean;
    like: boolean;
    share: boolean;
    more: boolean;
    edit: boolean;
  },
  className?: string,
  embed?: boolean
) => {
  return (
    <div
      className={classNames(
        'overflow-visible flex flex-col gap-md w-full items-center content-start',
        'pt-sm px-xs pb-sm',
        // RESPONSIVE STYLES
        'sm:flex-row sm:flex-wrap sm:items-start sm:px-xxl',
        className
      )}
    >
      {cardContents.map((cardContent) => (
        <GoalCard
          data-testid={`goalCard-goal-${cardContent.goal.entityId}`}
          key={cardContent.key}
          goal={cardContent.goal}
          showActions={showActions}
          goalSubscription={cardContent.subscription}
          embed={embed}
        />
      ))}
    </div>
  );
};

const GoalCardsGrid = ({
  embed = false,
  subscriptions,
  goals,
  showActions,
  className,
  ...props
}: GoalCardsGridProps) => {
  let cardContents: CardContent[] = [];

  // Add subscriptions first
  if (subscriptions) {
    cardContents = subscriptions.map((subscription) => ({
      key: `sub-${subscription.id}`,
      subscription: subscription,
      goal: subscription.goal
    }));
  }

  // Then add extra goals
  if (goals) {
    const goalContents = goals.map((goal) => ({
      key: `goal-${goal.entityId}`,
      goal: goal,
      subscription: goal.subscription
    }));
    cardContents = [...cardContents, ...goalContents];
  }

  return (
    <div
      {...props}
      className={classNames(
        'flex flex-wrap pt-sm gap-sm w-full',
        // RESPONSIVE STYLES
        'sm:py-sm'
      )}
    >
      {renderCards(cardContents, showActions, className, embed)}
    </div>
  );
};

export default GoalCardsGrid;
